module.exports = __webpack_public_path__ + "static/media/YF62_1.ebf511db.jpg";